import axios from 'axios';

const webCrawlerApi = {
  /**
   * Discovery endpoints
   */
  async getDiscoveries(baseUrl = null) {
    const params = {};
    if (baseUrl) {
      params.base_url = baseUrl;
    }
    const response = await axios.get('/web_crawler/discovery', {
      params,
    });
    return response.data;
  },

  async createDiscovery(payload) {
    const response = await axios.post('/web_crawler/discovery', payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  },

  /**
   * Profile endpoints
   */
  async getProfiles() {
    const response = await axios.get('/web_crawler/profiles');
    return response.data;
  },

  async getProfile(profileId) {
    const response = await axios.get(`/web_crawler/profiles/${profileId}`);
    return response.data;
  },

  async createProfile(payload) {
    const response = await axios.post('/web_crawler/profiles', payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  },

  async updateProfile(profileId, payload) {
    const response = await axios.patch(
      `/web_crawler/profiles/${profileId}`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  },

  async updateProfileUrlTargets(profileId, rules) {
    const response = await axios.patch(
      `/web_crawler/profiles/${profileId}/url_targets`,
      { rules },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  },

  async runProfile(profileId, runConfig = {}) {
    const response = await axios.post(
      `/web_crawler/profiles/${profileId}/run_urls`,
      runConfig,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  },

  /**
   * Job endpoints
   */
  async getJobs(profileId = null) {
    const params = {};
    if (profileId) {
      params.profile_id = profileId;
    }
    const response = await axios.get('/web_crawler/jobs', {
      params,
    });
    return response.data;
  },

  async getJob(jobId) {
    const response = await axios.get(`/web_crawler/jobs/${jobId}`);
    return response.data;
  },

  /**
   * Auto-generation endpoints
   */
  async autoGenerateSchemaAndChain(payload) {
    const response = await axios.post(
      '/web_crawler/destinations/auto-generate',
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  },
};

export default webCrawlerApi;
